// extracted by mini-css-extract-plugin
module.exports = {"showBlock":"SingleShow_showBlock__1-1o_","showInfo":"SingleShow_showInfo__2teTJ","showSummary":"SingleShow_showSummary__gKo50","btn_episodes":"SingleShow_btn_episodes__3xyxC"};